import { k } from '../../localization/t';

export const FOIL_LABEL = { F: k('Foil') };
export const FOIL_LABEL_COLOR = { F: 'text-cyan-400' };
export const FOIL_OVERLAY_CLASSES = 'foil-overlay foil-overlay--always';

export function isFoilFinish(foiling) {
  return foiling === 'F';
}

// Resolve which printing of a card to display: by exact id, then by requested
// finish, then whatever the card has.
//
// The middle step is the one that matters and the one that kept getting
// forgotten. Nearly every card carries both a Standard and a Foil variant and
// the Standard sorts first (1092 of the 1095 dual-variant cards), so falling
// straight from a missed id to printings[0] silently downgrades a foil to a
// non-foil. Downstream that reads as foiling:'S', which means DeckCardTile never
// mounts its live FoilCanvas. A foil reward renders as a plain card that only
// picks up the generic hover sheen.
//
// `foiling` is the finish to fall back to: 'F' for surfaces that are foil by
// definition (season/draft prizes), or the finish the server sent alongside the
// id for rolled contents (packs, picks, auction listings).
export function resolvePrinting(card, printingId, foiling = 'S') {
  const printings = card?.printings;
  if (!printings?.length) return null;
  return printings.find((p) => p.unique_id === printingId)
    || printings.find((p) => (p.foiling || 'S') === foiling)
    || printings[0];
}
